import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type {
  ActionStatus,
  ActivityActionTranslationKeys,
  ActivityCategory,
} from 'lumen/utils/constants/activity-action-constants';

export interface ActivityAction {
  key: ActivityActionTranslationKeys;
  values: Record<string, string>;
}

export const ACTOR_TYPES = ['system', 'lighthouse_staff'] as const;
export type ActorType = (typeof ACTOR_TYPES)[number];

export interface UserActor {
  email: string;
  name: string;
  user_id: number;
}

export interface NonUserActor {
  actor_type: ActorType;
  name: string;
}

export type ActivityActor = NonUserActor | UserActor;

export function isNonUserActor(actor: ActivityActor): actor is NonUserActor {
  return 'actor_type' in actor;
}

export default class ActivityLog extends Model {
  [Type] = 'activity-log' as const;

  @attr declare action: ActivityAction;
  @attr('string') declare actionStatus: ActionStatus;
  @attr declare actor: ActivityActor;
  @attr('string') declare category: ActivityCategory;
  @attr declare changes: Record<string, [string | null, string | null]> | null;
  @attr('string') declare ipAddress: string;
  @attr('string') declare location: string;
  @attr('dayjs') declare timestamp: DayjsTransformReturn;
}
